function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHangIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Hang in",
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 231",
    style: {
      stroke: "rgba(247,247,247,.7)",
      strokeWidth: 4,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 156,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 154,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1995",
    d: "M547.379 169.963a2.684 2.684 0 0 1-.547-.037 73.251 73.251 0 1 1 47.174-135.29 4.255 4.255 0 0 1-4.4 7.286 64.7 64.7 0 1 0-41.7 119.564 4.266 4.266 0 0 1-.529 8.5z",
    transform: "translate(-400.007 58.994)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1996",
    d: "M562.172 57.6a4.258 4.258 0 0 1-3.929-2.626c-.341-.812-.681-1.625-1.059-2.437a4.256 4.256 0 1 1 7.727-3.571c.417.907.832 1.833 1.21 2.758a4.261 4.261 0 0 1-2.306 5.555 4.411 4.411 0 0 1-1.606.321z",
    transform: "translate(-342.403 76.653)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1997",
    d: "M541.068 139.274a4.251 4.251 0 0 1-1.663-8.163 62.608 62.608 0 0 0 4.553-2.154 4.255 4.255 0 0 1 3.949 7.539c-1.682.87-3.4 1.7-5.157 2.438a4.377 4.377 0 0 1-1.662.34zm18.132-11.356a4.184 4.184 0 0 1-3.211-1.474 4.247 4.247 0 0 1 .435-5.989 72.372 72.372 0 0 0 3.684-3.439 4.249 4.249 0 1 1 6.046 5.97 67.382 67.382 0 0 1-4.156 3.892 4.206 4.206 0 0 1-2.779 1.039zm13.8-16.343a4.306 4.306 0 0 1-2.21-.624 4.242 4.242 0 0 1-1.417-5.838 63.255 63.255 0 0 0 2.436-4.4 4.246 4.246 0 0 1 7.577 3.835 66.771 66.771 0 0 1-2.778 4.988 4.207 4.207 0 0 1-3.626 2.041zm8.124-19.782a4.354 4.354 0 0 1-.982-.113 4.251 4.251 0 0 1-3.156-5.12q.567-2.409.964-4.931a4.254 4.254 0 0 1 8.408 1.3 71.7 71.7 0 0 1-1.1 5.592 4.27 4.27 0 0 1-4.135 3.272zm1.645-21.331a4.256 4.256 0 0 1-4.232-3.911 63.048 63.048 0 0 0-.586-5.007 4.254 4.254 0 1 1 8.408-1.3c.283 1.852.51 3.76.661 5.649a4.254 4.254 0 0 1-3.911 4.572z",
    transform: "translate(-358.031 84.761)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1998",
    d: "M530.8 109.694a4.248 4.248 0 0 1-.53-8.463 105.66 105.66 0 0 0 2.627-.38 4.253 4.253 0 0 1 1.4 8.39c-.982.169-1.984.3-2.965.435-.189.018-.36.037-.549.037z",
    transform: "translate(-366.009 119.292)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1999",
    d: "m569.379 50.237-8.6-21.482a3.44 3.44 0 0 0-5.9-.85L540.565 46.1a3.439 3.439 0 0 0 2.211 5.536l22.9 3.307a3.44 3.44 0 0 0 3.683-4.686z",
    transform: "translate(-355.677 61.021)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2000",
    d: "M543.259 40.052a44.386 44.386 0 1 0 44.219 44.386 44.3 44.3 0 0 0-44.219-44.386zm21.76 68.559a5.608 5.608 0 0 1-3.945 1.61 5.7 5.7 0 0 1-4.057-1.724L539.2 90.1a5.729 5.729 0 0 1-1.6-3.959v-28a5.662 5.662 0 1 1 11.323 0v25.691l16.213 16.728a5.7 5.7 0 0 1-.114 8.032z",
    transform: "translate(-387.47 71.549)",
    style: {
      fill: "#0f8560"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangIn);
export default __webpack_public_path__ + "static/media/hang-in.007bea59.svg";
export { ForwardRef as ReactComponent };